module.exports = __webpack_public_path__ + "static/media/tp3.cfc9c5cb.jpg";